import * as d3 from "d3";
import $ from 'jquery';
import { addCommas, genderTooltip, mcjPopulationTooltip } from './helpers';
import * as axios from 'axios';

function resize() {
    const facilityData = axios.get("https://docs.google.com/spreadsheets/d/e/2PACX-1vRb8zyDNZXyPrSgwxUxENm2jKPV-ewDJF_CbEGWvCNuYzXZT_6YwCv209lTeyI6tUIL6jRl6ZWD5Dcv/pub?gid=1704181121&single=true&output=csv")
        .then(content => {
            const justData = content.data
            const facilities = d3.csvParse(justData)

            var parseDate = d3.timeParse("%Y-%m-%d");
            facilities.forEach(function (d) {
                d.newDate = parseDate(d.date);
            })
            facilities.sort((a, b) => a.newDate - b.newDate)

            const datalength = facilities.length

            const currentDate = facilities[datalength - 1].newDate

            var formatDate = d3.timeFormat("%Y-%m-%d");

            const allCurrentDate = facilities.filter(d => d.date == formatDate(currentDate))

            //case data
            const caseDataCurrent = d3.nest()
                .key(d => d.group)
                .rollup(v => d3.sum(v, d => d.value))
                .object(allCurrentDate);

            const totalCurrent = d3.nest()
                .rollup(v => d3.sum(v, d => d.value))
                .object(allCurrentDate);

            // //3/30/2021 numbers:
            // const pretrial_mar2021 = 5713,
            //     partially_sentenced_mar2021 = 3070,
            //     sentenced_mar2021 = 2015,
            //     transfer_mar2021 = 3901,
            //     total_mar2021 = 15262;

            // // current numbers (4/29)
            // const pretrial_current = 5634,
            //     partially_sentenced_current = 3043,
            //     sentenced_current = 1961,
            //     transfer_current = 3843,
            //     total_current = 15016;

            // //target numbers:
            // const pretrial_target = 3448,
            //     partially_sentenced_target = 1968,
            //     sentenced_target = 2063,
            //     transfer_target = 700,
            //     total_target = 8179;

            const mcjPopulations = ["En espero de juicio", "Condenados parcialmente", "Condenados", "Personas en espera de ser trasladadas a una prisión estatal", "Población encarcelada total"]

            const targets = [3488, 1968, 2063, 700, 8179]
            const march = [5713, 3070, 2015, 3901, 15262]
            const currentNumbers = [caseDataCurrent.Pretrial, caseDataCurrent["Partially Sentenced"], caseDataCurrent["Fully Sentenced"], caseDataCurrent["Awaiting State Prison"], totalCurrent]

            // const changes = [3.3, 5.6, 112.5, .66, 1.1]

            const mcj = []
            for (let i = 0; i < mcjPopulations.length; i++) {
                // let targetProgress = targets[i] - currentNumbers[i]

                //let targetProgress = (currentNumbers[i] / targets[i]) * 100


                let targetProgress
                if (targets[i] - currentNumbers[i] >= 0 || targets[i] - march[i] >= 0) {
                    targetProgress = 100
                    // targetProgress = ((targets[i] / march[i]) - ((targets[i] / currentNumbers[i]) - (targets[i] / march[i]))) * 100
                }
                else { targetProgress = ((currentNumbers[i] - march[i]) / (targets[i] - march[i])) * 100 }
                mcj.push({
                    population: addCommas(mcjPopulations[i]),
                    Objetivo: addCommas(+targets[i]),
                    ['Marzo 30']: addCommas(march[i]),
                    Actual: addCommas(currentNumbers[i]),
                    Change: targetProgress
                })
            }

            const mcjData = [];
            mcj.forEach(function (row) {
                Object.keys(row).forEach(function (colname) {
                    if (colname == "population" || colname == "value") {
                        return
                    }
                    mcjData.push({ "population": row["population"], "value": row[colname], "category": colname });
                });
            });

            mcjPopulationTooltip()


            var containerWidth = +d3.select('#wrap').style('width').slice(0, -2)

            var margin = { top: 0, right: 85, bottom: 0, left: 0 },
                width = (containerWidth * .39) - margin.left - margin.right,
                height = 40 - margin.top - margin.bottom;

            var x = d3.scaleLinear()
                .range([0, width]);

            var y = d3.scaleBand()
                .range([0, height])
                .padding(0.1);

            var xAxis = d3.axisBottom(x)

            var yAxis = d3.axisLeft(y)
                .tickSize(0)
                .tickPadding(6);

            const csv = mcjData;

            csv.forEach(function (d) {
                d.value = d.value;
            });

            var nestyr = d3.nest()
                .key(function (d) { return d.category; })
                .object(csv);

            var yearstring = Object.keys(nestyr);

            x.domain(d3.extent(csv.filter(d => d.category == "Change"), d => d.value)).nice();
            y.domain(csv.map(d => d.name));

            var type = d3.nest()
                .key(function (d) { return d.population; })
                .entries(csv);

            var tableData = [],
                populations = {};
            csv.forEach(function (d) {
                var population = populations[d.population];
                if (!population) {
                    tableData.push(population = populations[d.population] = {});
                }
                population[d.category] = d.value,
                    populations[d.population].Grupo = d.population;
            });

            yearstring.unshift("Grupo");
            yearstring.pop("Change");
            yearstring.push("Progreso desde el 30 de marzo de 2021");

            tabulate(csv, tableData, yearstring);

            function tabulate(csv, newData, columns) {

                var type = d3.nest()
                    .key(function (d) { return d.population; })
                    .entries(csv);

                var table = d3.select('#wrapper').append('div').attr('class', 'Rtable Rtable--5cols Rtable--collapse')
                var thead = table.append('div').attr('class', 'Rtable-row Rtable-row--head')

                // append the header row
                thead
                    .selectAll('.column-heading')
                    .data(columns).enter()
                    .append('div')
                    .attr("class", (d, i) => 'Rtable-cell column-heading ' + columns[i])
                    .text(function (column) { return column; });

                // create a row for each object in the data
                var rows = table.selectAll('.Rtable-row-main')
                    .data(newData)
                    .enter()
                    .append('div')
                    .attr('class', 'Rtable-row-main');

                // create a cell in each row for each column
                var cells = rows.selectAll('.Rtable-cell')
                    .data(function (row) {
                        return columns.map(function (column) {
                            return { column: column, value: row[column] };
                        });
                    })
                    .enter()
                    .append('div')
                    .attr("class", (d, i) => 'Rtable-cell ' + columns[i])

                cells.append('div')
                    .attr('class', 'Rtable-cell--heading')
                    .text(function (column) {
                        return column.column;
                    });

                cells.append('div')
                    .attr('class', 'Rtable-cell--content')
                    .html(function (d) {
                        return d.value;
                    });

                var bars = rows.selectAll(".Progreso")
                    .selectAll(".change")
                    .data(function (d, i) {
                        return [type[i]];
                    })
                    .enter()
                    .append("svg")
                    .attr("width", width + margin.left + margin.right)
                    .attr("height", height + margin.top + margin.bottom)
                    .append("g")
                    .attr("transform", "translate(" + margin.left + "," + margin.top + ")")
                    .attr("class", "change")

                bars
                    .append("text")
                    .attr("class", "bar text")
                    .attr("x", d => {
                        if (d.values[3].value >= 0) {
                            return x(d.values[3].value) + 5
                        } else {
                            return x(0) + 5
                        }
                    })
                    .attr("y", (height / 2) + 8)
                    // .text(d => (d.values[2].value).toFixed(0))
                    .text(d => {
                        if (d.values[3].value == 100) {
                            return (d.values[3].value).toFixed(0) + '+%'
                        } else {
                            return (d.values[3].value).toFixed(1) + '%'
                        }
                    })

                bars
                    .append("rect")
                    .attr("class", function (d) {
                        return "bar bar--" + (d.values[3].value < 0 ? "negative" : "positive");
                        //                    return "bar bar--" + (d.values[2].value < 100 ? "positive" : "negative");
                    })
                    .attr("x", d => x(Math.min(0, d.values[3].value)))
                    .attr("y", 0)
                    .attr("width", d => Math.abs(x(d.values[3].value) - x(0)))
                    .attr("height", 40)

                return table;
            };

        })
}
d3.select(window).on("resize", resize);

resize()